import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityIncidentLogSlice } from './get';

import { coreDataSecurityIncidentLogExportReducers, coreDataSecurityIncidentLogExportWatchers } from './export';

export const coreDataSecurityIncidentLogReducers = combineReducers({
	export: coreDataSecurityIncidentLogExportReducers,
	get: getCoreDataSecurityIncidentLogSlice.asyncReducers
});

export const coreDataSecurityIncidentLogWatchers = combineAllWatchers([
	coreDataSecurityIncidentLogExportWatchers,
	getCoreDataSecurityIncidentLogSlice.asyncWatchers
]);
